module.exports = __webpack_public_path__ + "img/traffic-junction-3.839c9a0b.webp";